import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('TileSkeleton')

const propTypes = {
    className: PropTypes.string
}

function TileSkeleton({ className }) {
    return (
        <li className={bem(null, null, className)}>
            <Skeleton containerClassName={bem('skeletonImageWrapper')} className={bem('skeletonImage')} />
            <Skeleton
                count={2}
                align="left"
                containerClassName={bem('skeletonTextWrapper')}
                className={bem('skeletonText')}
            />
        </li>
    )
}

TileSkeleton.propTypes = propTypes

export default TileSkeleton
